// src/pages/HomePage.js
import React from 'react';
import Hero from '../components/Hero';
import AboutUs from '../components/AboutUs';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const HomePage = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <AboutUs />
      <ContactUs/>
      <Footer />
    </div>
  );
};

export default HomePage;
